module.exports = __webpack_public_path__ + "img/name.ad97cbbd.svg";